import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import apiverson from '../../../common/apiverson.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {
  setOrdersStateAndEnsureProductsLoaded,
  orderSelector,
} from '../../../data/orders.js'
import {refreshOrderListAndCounts} from '../orderListActions.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {plural, Plural, PluralBlock} from '../../../common/components/Plural.js'

export const MODAL_FORM = 'confirm_order_on_hold_modal'

export function showConfirmOrderOnHoldModal(orderNumbers, hold = true) {
  setForm(MODAL_FORM, {
    orderNumbers,
    hold,
    willDeleteTracking: false,
    isSaving: false,
    serverError: null,
    notifyCart: false,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  const forms = formsSelector(state)

  return forms[MODAL_FORM]
}

export async function holdOrder(orderNumber, hold) {
  const order = orderSelector(getState(), {orderNumber})

  const {json: updatedOrder} = await apiverson.post(
    `${order.link}/${hold ? 'hold' : 'unhold'}`,
  )

  return updatedOrder
}

export async function holdOrders() {
  try {
    const {orderNumbers, hold} = modalFormSelector(getState())

    updateModalForm({isSaving: true, serverError: null})

    const orders = await Promise.all(
      orderNumbers.map((orderNumber) => holdOrder(orderNumber, hold)),
    )

    await setOrdersStateAndEnsureProductsLoaded(orders)

    refreshOrderListAndCounts()

    const orderString = orders.length > 1 ? 'orders were' : 'order was'
    showMessageToast(
      `${orders.length} ${orderString} successfully ${hold ? 'put on hold' : 'removed from on hold'}.`,
    )

    closeModal()
  } catch (err) {
    updateModalForm({
      serverError: `Error managing orders on hold status: ${
        err.message || err.error_message
      }`,
      isSaving: false,
    })
  }
}

function ConfirmOrderOnHoldModal({form}) {
  return (
    <ConfirmModal
      title={
        form.hold
          ? plural(form.orderNumbers)`Put Order${['s']} On Hold`
          : `Remove Order Hold`
      }
      onConfirm={() => holdOrders()}
      onCancel={() => closeModal()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <PluralBlock array={form.orderNumbers}>
        <p className="fs-01 lh-md margin-bottom-0">
          {form.hold ? (
            <strong>
              Are you sure you want to put{' '}
              <Plural s="this order" p="these orders" /> on hold?
            </strong>
          ) : (
            <strong>
              Are you sure you want to remove the hold on{' '}
              <Plural s="this order" p="these orders" />?
            </strong>
          )}
        </p>
      </PluralBlock>
    </ConfirmModal>
  )
}

export default onlyIfForm(ConfirmOrderOnHoldModal, modalFormSelector)
